import Rellax from 'Rellax';

function parallax() {
  if (document.querySelector('.parallax')) {
    new Rellax('.parallax');
  }
}

parallax();

export { parallax };
